module.exports = "<header>\n    <div class=\"logo\"></div>\n</header>\n"